<div class="footer-module">
  <div class="texture">
    Pickup Student created by
    <a class="link" (click)="navigateToAuthorPage()">BusMap</a>
  </div>
</div>
